export enum AnnotatorErrorType {
  PDF_LOADING_ERROR = "PDF_LOADING_ERROR",
  DOCUMENT_DATA_LOAD_ERROR = "DOCUMENT_DATA_LOAD_ERROR",
}
